<template>
  <div class="aboutUs" style="min-height:300px;">
    <div class="sizeme">
      <h2>Get Quote</h2>
      <p>
        For a free quote please fill the form below and we would be in touch
        with you to discuss the quote and how further we can help you.
      </p>
    </div>
    <quote-form/>
  </div>
</template>

<script>
import db from '../../config/db'
import Swal from 'sweetalert2'
import QuoteForm from '../components/forms/quoteForm.vue'

export default {
  name: 'aboutUs',
  components: {
    QuoteForm
  },
  data () {
    return {
      testimony: [],
      testClick: false,
      newtestimony: {
        name: '',
        location: '',
        description: '',
        imagename: ''
      },
      token: '',
      files: '',
      pageOfItems: []
    }
  },
  mounted () {
    this.getDB()
    this.$store.commit('checkENV')
  },
  methods: {
    toggleClick () {
      if (this.testClick === false) {
        this.testClick = true
      } else if (this.testClick === true) {
        this.testClick = false
      }
    },
    checkToken () {
      const vm = this
      db.firestore
        .collection('token' + this.$store.state.env)
        .doc('access')
        .get()
        .then(function (doc) {
          if (vm.token === doc.data().token) {
            vm.addDB()
            vm.storeFiles()
            vm.notication('Success', 'success')
            vm.testClick = false
            vm.newtestimony = {}
            vm.token = ''
          } else {
            vm.notication('Invalid Token', 'error')
          }
        })
    },
    addDB () {
      const vm = this
      if (this.$refs.myFiles.files.length === 1) {
        this.newtestimony.imagename = this.$refs.myFiles.files[0].name
      } else {
        this.newtestimony.imagename = 'no-image.png'
      }
      db.firestore.collection('/testimony' + this.$store.state.env).add({
        name: this.newtestimony.name,
        location: this.newtestimony.location,
        Description: this.newtestimony.description,
        imageName: this.newtestimony.imagename,
        timestamp: new Date()
      }).then(setTimeout(() => { vm.getDB() }, 2000))
    },
    storeFiles () {
      if (this.newtestimony.imagename !== 'no-image.png') {
        const fileInfo = this.$refs.myFiles.files[0]
        db.storing.ref(
          'images' + this.$store.state.env + '/' +
          fileInfo.name
        ).put(fileInfo)
      }
    },
    getDB () {
      const vm = this
      let testimonyinfo = []
      let data = {}
      db.firestore.collection('testimony' + this.$store.state.env)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            // Using image name to obtain image url
            db.storing.ref('images' + this.$store.state.env + '/')
              .child(doc.data().imageName)
              .getDownloadURL()
              .then((downloadURL) => {
                data = {
                  id: doc.id,
                  name: doc.data().name,
                  location: doc.data().location,
                  description: doc.data().Description,
                  imageURL: downloadURL,
                  timestamp: doc.data().timestamp
                }
                testimonyinfo.push(data)
                testimonyinfo = testimonyinfo.sort(
                  (a, b) => b.timestamp - a.timestamp
                )
              })
          })
        })
      vm.testimony = testimonyinfo
    },
    notication (text, icon) {
      Swal.fire({
        title: text,
        icon: icon,
        timer: 1500,
        showConfirmButton: false
      })
    },
    onChangePage (pageOfItems) {
      this.pageOfItems = pageOfItems
      // window.scrollTo(0, 150)
    }
  }
}

</script>

<style lang="scss" scoped>

</style>
